import { Type } from "@sinclair/typebox";

export const DomainsRequestSchema = Type.Array(
  Type.String({ format: "hostname" }),
);
